import React, { useRef } from 'react';
import {
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import Xarrow from 'react-xarrows';

import '../../../scss/Pages/_locHistory.scss';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';

const LocationLogsList = ({ locations, isLoading, noLocs }) => {
  const {
    techsGHLLEmpty,
  } = useTranslationHook();

  const box1Ref = useRef(null);
  const box2Ref = useRef(null);
  const box3Ref = useRef(null);

  return (
    <Box className="listComponentContainer">
      {isLoading ? (
        <Box display='flex' justifyContent='center' paddingY={10}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {noLocs ? (
            <Box textAlign='center' paddingY={10}>
              {techsGHLLEmpty}
            </Box>
          ) : (
            <List
              sx={{
                height: "100%",
                overflowY: 'auto',
              }}
            >
              {locations.map((locationLog) => {
                return (
                  <ListItem
                    key={locationLog.id}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Box
                      ref={box1Ref}
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <ListItemIcon>
                        <CircleIcon
                          sx={{ color: 'lightgreen', fontSize: '2rem' }}
                        />
                      </ListItemIcon>
                    </Box>
                    <Box ref={box2Ref} paddingRight={5}>
                      <ListItemText
                        primary={
                          locationLog.latitude + ', ' + locationLog.longitude
                        }
                        className='latLongContainer'
                        onClick={() => {
                          window.open(
                            'https://maps.google.com?q=' +
                              locationLog.latitude +
                              ',' +
                              locationLog.longitude
                          );
                        }}
                      />
                    </Box>
                    <Box ref={box3Ref} marginLeft='auto' paddingLeft={5}>
                      <ListItemText
                        primary={locationLog.register_at.toLocaleDateString()}
                        secondary={locationLog.register_at.toLocaleTimeString(
                          undefined,
                          { hour12: false, hour: '2-digit', minute: '2-digit' }
                        )}
                      />
                    </Box>
                    <Xarrow
                      start={box2Ref}
                      end={box3Ref}
                      strokeWidth={2}
                      showHead={false}
                      path='straight'
                      color='#dee2ec'
                    />
                  </ListItem>
                );
              })}
            </List>
          )}
        </>
      )}
    </Box>
  );
};

export default LocationLogsList;
